import { CREATE_AND_EDIT_EMAIL_TEMPLATES } from './constants';

export const es = {
  [CREATE_AND_EDIT_EMAIL_TEMPLATES]: {
    DAY: 'día',
    DAYS: 'días',
    SUCCESS_TITLE_CREATE_TEMPLATE: 'Plantilla creada con éxito',
    TOAST_TITLE_CREATE_TEMPLATE_ERROR: 'Error al crear la plantilla',
    SUCCESS_TITLE_RESET: 'Plantilla restablecida con éxito',
    TOAST_TITLE_RESET_ERROR: 'Error al restablecer la plantilla',
    RECRUITMENT: 'Reclutamiento',
    CONFIGURATION: 'Configuración',
    EMAIL_TEMPLATES: 'Plantillas de correo',
    TEMPLATE_DETAIL: 'Detalle plantilla',
    NEW_TEMPLATE: 'Nueva plantilla',
    CANCEL: 'Cancelar',
    ADD_NAME_TEMPLATE: 'Añade un nombre a la plantilla',
    IN_DRAFT: 'En borrador',
    TITLE_SCHEDULE_SHIPMENT: 'Programar envío',
    FIRST_DESCRIPTION_SCHEDULE_SHIPMENT:
      'Usa esta opción para notificar al candidato que no continuará en el proceso uno o más días después de su descarte. El correo se enviará solo en días hábiles (lunes a viernes).',
    SECOND_DESCRIPTION_SCHEDULE_SHIPMENT:
      '*Si no está activada, el envío será automático tras el descarte.',
    NUMBER_OF_DAYS: 'Número de días',
    SHIPPING_TIME: 'Horas de envío',
    RESTORE_TEMPLATE: 'Restaurar plantilla',
    SEND_TEST_EMAIL: 'Enviar correo de prueba',
    SAVE_AND_EXIT: 'Guardar y salir',
    TITLE_RESTORE_TEMPLATE: '¿Deseas restaurar la plantilla ?',
    DESCRIPTION_RESTORE_TEMPLATE:
      'Todos los cambios realizados se perderán, y el contenido volverá a su estado predeterminado.',
    YES_RESTORE: 'Sí,restaurar',
    LOADING_TEXT: 'Cargando...',
    TITLE_TEST_MAIL_SENDING: '¿Deseas enviar correo de prueba?',
    DESCRIPTION_TEST_MAIL_SENDING: 'Recuerda que se te enviará el correo a:',
    YES_SEND: 'Si, enviar',
    TITLE_UNSAVED_CHANGES: 'Tienes cambios sin guardar ¿Deseas salir?',
    DESCRIPTION_UNSAVED_CHANGES: 'Todos los cambios realizados se perderán.',
    EXIT_WITHOUT_SAVING: 'Salir sin guardar',
    BACK_TO_EDITING: 'No, volver a la edición',
    NOTIFICATION_REEMPLACE: 'Reemplazar imagen',
    NOTIFICATION_IMAGE_SIZE:
      'Tamaño: 600 x 192 px, Max: 2 MB, Formato: PNG, JPG',
    NOTIFICATION_LOADING: 'Cargando...',
    NOTIFICATION_PROGRESS_LABEL: 'Cargando imagen...',
    NOTIFICATION_ERROR_NUMBER_FILES:
      'Solo puedes subir hasta {{MAX_FILES}} archivos.',
    NOTIFICATION_ERROR_SIZE:
      'El archivo no cumple con los requisitos de tamaño ',
    SUBJECT_EMAIL: 'Asunto del correo',
    REQUIRED_SUBJECT: '(Obligatorio)',
    NOTIFICATION_SUBMIT_PLACEHOLDER: 'Ingresa un asunto',
    PLACEHOLDER_SUBJECT_EMAIL: 'Completar campo',
    UPLOAD_ATTACHMENT: 'Subir archivo adjunto',
    MAX_ATTACHMENTS_SIZE: '(Máx. 3 archivos, peso máx: 20MB)',
    NOTIFICATION_ERROR_LABEL: 'Error al cargar el archivo',
    NOTIFICATION_ERROR_EXTENSION:
      'El archivo no cumple con el formato requerido',
    NOTIFICATION_RETRY: 'Reintentar',
    USER_DIALOG_DELETE_BUTTON_CANCEL: 'Cancelar',
    NOTIFICATION_ATTACHMENT_RETRY: 'Reintentar',
    FILE_SIZE_ERROR: 'El archivo no cumple con los requisitos de tamaño',
    ERROR_UPLOAD_FILE: 'Error al cargar el archivo',
    NOTIFICATION_DRAG_IMAGE: 'Arrastra tu imagen para cargarla o',
    NOTIFICATION_CHOOSE_FILE: 'elige tu archivo',
    NOTIFICATION_TITLE_PLACEHOLDER: 'Ingresa un título',
    NOTIFICATION_TEXTAREA_PLACEHOLDER: 'Escribe el cuerpo del mensaje',
    MAX_LENGTH_TITLE: 'Máximo 58 caracteres',
    NAME_EMPLOYEE: '{NAME_EMPLOYEE}',
    NAME_ORGANIZATION: '{NAME_ORGANIZATION}',
    NAME_VACANCY: '{NAME_VACANCY}',
    NAME_EMPLOYEE_LABEL: 'Nombre de empleado',
    NAME_ORGANIZATION_LABEL: 'Nombre de organización',
    NAME_VACANCY_LABEL: 'Nombre de vacante',
    DELETE_FILE: 'Eliminar',
    UPLOADING_FILE: 'Subiendo archivo',
    SUCCESS_TITLE_SEND_TEST_EMAIL:
      'El correo de prueba se envió correctamente.',
    SUCCESS_DESCRIPTION_SEND_TEST_EMAIL:
      'Revisa tu casilla de correo o mensajes no deseados.',
    FILE_EXTENSION_ERROR: 'El archivo no cumple con el formato requerido',
    FILE_PREVIEW_ERROR: 'Error al crear el preview del archivo',
    TOAST_TITLE_SEND_TEST_EMAIL_ERROR: 'Error al enviar el correo de prueba',
    TOAST_DESCRIPTION_SEND_TEST_EMAIL_ERROR:
      'Por favor, inténtalo de nuevo más tarde.',
    LOADING_TEXT_SEND_TEST_EMAIL: 'Enviando...',
    UPLOAD_DOCUMENTS: 'Subir documentos',
  },
};
